import React from 'react'
import { Link } from 'react-router'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'

export default class extends React.Component {
  componentDidMount() {
    setDocumentTitle('Terms of service')
  }

  render() {
    return (
      <div className="agreement">
     <h2>Notes</h2>
<br />
The operator of "Yayya" (hereinafter referred to as "we") reminds users to carefully read this User Agreement (hereinafter referred to as "the Agreement") and ensure you fully understand its terms before registering. Your registration, login, and use of our services will be deemed as acceptance of the Agreement. If you do not agree to the terms, you are not permitted to register, log in, or use the services.
<br /><br />
This Agreement outlines the rights and responsibilities between Yayya and users regarding the Yayya app and its services (hereinafter referred to as the "Service"). A "user" is any individual who registers, logs in, or uses the Service. If Yayya updates the terms, and you do not accept them, you must stop using the Service. Continued use constitutes agreement to the updated terms.
<br /><br />
<h3>I. Account Registration</h3>
1. Users must register for a Yayya account to access the Service. The account must be linked to a unique phone number or third-party account not previously used or banned under this Agreement.<br />
2. Users logging in with Snapchat must be at least 18 years old.
<br /><br />
<h3>II. Service Content</h3>
1. Yayya provides features including but not limited to messaging, adding friends, joining groups, creating rooms, and voice chats. Features may change over time.<br />
2. Services may be free or paid. Users can purchase virtual currency (Gold Coins) using provided payment methods. These coins may be used to access paid features. Yayya will notify users clearly before payment is required. Payment is considered complete upon confirmation from the payment platform or bank.
<br /><br />
<h3>III. Protection of Personal Information</h3>
1. Yayya is committed to protecting user privacy.<br />
2. Users may need to provide personal data (e.g., phone number, avatar, device info) to access services. Yayya secures this data using encryption, anonymization, and other technical safeguards.<br />
3. For more details, refer to Yayya’s Privacy Policy.<br />
4. To delete your information, you may:
<br />
(1) Use the login page Feedback button<br />
(2) Navigate to: I > Feedback within the app<br />
(3) Use: Me > Settings > Delete Account
<br /><br />
<h3>IV. Content Guidelines</h3>
1. Content includes any user-submitted data such as profile info, messages, or media.<br />
2. Users may not post content that:
<br />
- Is sexually explicit<br />
- Abusive, threatening, or harassing<br />
- Spam or deceptive<br />
- Violates privacy of others<br />
- Infringes legal rights (e.g., IP, reputation)<br />
- Interferes with the Service or harms others
<br /><br />
<h3>V. Virtual Currency</h3>
1. Yayya may offer Gold Coins to access premium services (e.g., virtual gifts). Coins have no value outside the platform.<br />
2. Users are responsible for entering correct account details. Yayya does not compensate for errors caused by user input.<br />
3. Coins are non-refundable and non-transferable unless required by law.<br />
4. Coins may not be traded outside Yayya. Suspected fraud may lead to account restriction.<br />
5. Yayya may update transaction limits or rules without user objection.<br />
6. Paid services are non-refundable unless stated otherwise by law.<br />
7. Users are responsible for any issues arising from:
<br />
- Account bans or losses<br />
- Sharing passwords<br />
- Payment account errors<br />
- Other users’ misconduct
<br />
8. Accounts violating terms or laws may be suspended or banned. Gold Coins may be frozen or forfeited.
<br /><br />
<h3>VI. Account Management</h3>
1. Yayya owns all accounts. Registered users receive usage rights, which are non-transferable.<br />
2. Users may view, modify, or delete data via the "My" page. Deleting data may remove stored text/images.<br />
3. Users are responsible for protecting account credentials and will be liable for misuse.<br />
4. Yayya may suspend services for any account violating the Agreement.
<br /><br />
<h3>VII. Intellectual Property</h3>
1. All content provided by Yayya (e.g., web pages, texts, media) is the intellectual property of Yayya unless users legally own submitted content.<br />
2. All software IP used in the Service belongs to Yayya.<br />
3. Logos and trademarks (collectively, "App Logo") are property of Yayya. Unauthorized use is prohibited.<br />
4. All IP protected by law must not be used or replicated without written permission.

      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/terms/index.js